module.exports = __webpack_public_path__ + "static/img/siswa.3e12a31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siswa.svg
// module id = 750
// module chunks = 1